module.exports = __webpack_public_path__ + "static/media/YF42_1.99324d29.jpg";